<template>
  <div class="user" v-if="mySelf">
    <v-card flat>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers_user"
            :items="filteredUsers"
            sort-by="lastname"
            class="elevation-1 caption"
            dense
            must-sort
            :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            :items-per-page="50"
            item-class="caption"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{title}}</v-toolbar-title>
                <br />
                <v-spacer></v-spacer>
                <v-btn v-if="activeMembers" small @click="activeMembers=!activeMembers">Zu ehemaligen Mitgliedern wechseln</v-btn>
                <v-btn v-else small @click="activeMembers=!activeMembers">Zu aktiven Mitgliedern wechseln</v-btn>

                <!--<v-divider class="mx-4" inset vertical></v-divider>-->
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  dense
                  single-line
                  hide-details
                  @input="editedIndex = -1"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn small @click="downloadCSV()">Download CSV</v-btn>
                <v-dialog v-model="dialog_user" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="subtitle-1">{{ formTitleUser }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-form
                        v-model="valid"
                        style="width: 100%; height: 100%"
                        class="compact-form"
                      >
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.nickname"
                          label="Angezeigter Kurzname"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.firstname"
                          label="Vorname"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.lastname"
                          label="Nachname"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          type="date"
                          required
                          v-model="editedItemUser.birthday"
                          label="Geburtstag"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.street"
                          label="Strasse/Hausnummer"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          type="number"
                          required
                          v-model="editedItemUser.postcode"
                          label="Postleitzahl"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.town"
                          label="Ort"
                        ></v-text-field>
                        <v-text-field
                          :rules="requiredRule"
                          required
                          v-model="editedItemUser.phone"
                          label="Telefon Nr."
                        ></v-text-field>
                        <!-- <v-checkbox
                          v-model="editedItemUser.member"
                          label="Mitgliedschaft aktiv"
                        >
                        </v-checkbox>
                        <v-text-field
                          type="date"
                          v-model="editedItemUser.membership_end"
                          label="Membership End"
                        ></v-text-field>-->
                        <v-text-field
                          :rules="emailRule"
                          required
                          v-model="editedItemUser.email"
                          label="E-Mail"
                        ></v-text-field>
                        <v-text-field
                          type="password"
                          v-model="editedItemUser.password"
                          label="Ausfüllen um neues Passwort setzen"
                        ></v-text-field>
                        <!-- <v-textarea
                          v-model="editedItemUser.member_of"
                          label="Member of"
                        ></v-textarea>-->
                        <v-list flat>
                          <v-list-item-group multiple>
                            <v-list-item
                              v-for="(item, i) in editedItemUser.member_of"
                              :key="i"
                            >
                              <v-list-item-action>
                                <v-checkbox v-model="item.active"></v-checkbox>
                              </v-list-item-action>

                              <v-list-item-content>
                                {{ getSectionName(item.section_id) }}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeUser"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="saveUser"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItemUser(item)"
                >mdi-pencil</v-icon
              >
            </template>
            <template v-slot:item.member_of="{ item }">
              {{comp_site(item.member_of)}}
              <!-- <div v-for="section of item.member_of">
                <div v-if="section.active">
                  {{ getSectionName(section.section_id) }}
                </div>
              </div> -->
            </template>
            <template v-slot:item.dsgvo="{ item }">
              <div v-if="item.dsgvo">
                <v-icon x-small class="mr-2">mdi-check</v-icon>
              </div>
              <div v-else>
                <v-icon x-small class="mr-2">mdi-cancel</v-icon>
              </div>
            </template>
            <template v-slot:item.e_invoice="{ item }">
              <div v-if="item.e_invoice">
                <v-icon x-small class="mr-2">mdi-check</v-icon>
              </div>
              <div v-else>
                <v-icon x-small class="mr-2">mdi-cancel</v-icon>
              </div>
            </template>
            <template v-slot:item.birthday="{ item }">
              {{item.birthday | moment('DD.MM.YYYY')}}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import api from "../api";
import { requiredRule, emailRule } from "../utils/rules";
import { downloadFile } from "../utils/files";
import { json2csv, json2csvAsync } from "json-2-csv";

export default {
  name: "user",
  components: {},
  data() {
    return {
      valid: false,
      requiredRule,
      emailRule,
      search: "",
      dialog_delete: false,
      //dialog_person: false,
      /*headers_person: [
        {
          text: "Number",
          align: "start",
          sortable: true,
          value: "number",
        },
        { text: "Name 1", value: "name1" },
        { text: "Name 2", value: "name2" },
        { text: "Street", value: "street" },
        { text: "Streetnumber", value: "street_number" },
        { text: "Code", value: "code" },
        { text: "Town", value: "town" },
        { text: "Country", value: "country" },
        { text: "VAT Nr", value: "vatnr" },
        { text: "Email", value: "comm[0]" },
        { text: "Phone Number", value: "comm[1]" },
        { text: "Updated at", value: "updatedAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],*/
      /*
      headers_person: [
        {
          text: "Number",
          align: "start",
          sortable: true,
          value: "number",
        },
        { text: "Short Name", value: "name1" },
        { text: "Full Name", value: "name2" },

        { text: "Email", value: "comm[0]" },
        { text: "Phone Number", value: "comm[1]" },

        { text: "Actions", value: "actions", sortable: false },
      ],
      editedIndexPerson: -1,
      editedItemPerson: {
        number: "",
        name1: "",
        name2: "",
        street: "",
        street_number: "",
        code: "",
        town: "",
        country: "",
        vatnr: "",
        comm: ["", ""],
      },
      defaultItemPerson: {
        number: "",
        name1: "",
        name2: "",
        street: "",
        street_number: "",
        code: "",
        town: "",
        country: "",
        vatnr: "",
        comm: ["", ""],
      },
  */
      dialog_user: false,
      headers_user: [
        { text: "Actions", value: "actions", sortable: false },
        {
          text: "Spitzname",
          align: "start",

          value: "nickname",
        },
        { text: "Vorname", value: "firstname" },
        { text: "Nachname", value: "lastname" },
        { text: "Geburtstag", value: "birthday" },
        { text: "Strasse", value: "street" },
        { text: "PLZ", value: "postcode" },
        { text: "Stadt", value: "town" },
        { text: "Telefon", value: "phone" },
        { text: "DSGVO", value: "dsgvo", align: "center" },
        { text: "E-Rechnung", value: "e_invoice", align: "center" },
        { text: "Mitglied von", value: "member_of" },
        //{ text: "Austrittsdatum", value: "membership_end" },
        { text: "Email", value: "email" },
        { text: "Berechtigung", value: "roles" },
        { text: "Email bestätigt", value: "activated" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      editedIndexUser: -1,
      editedItemUser: {
        nickname: "",
        firstname: "",
        lastname: "",
        birthday: null,
        street: "",
        postcode: null,
        town: "",
        phone: "",
        password: "",
        email: "",
        password: "",
        membership_end: null,
        member: false,
        roles: [],
        activated: true,
      },
      defaultItemUser: {
        nickname: "",
        firstname: "",
        lastname: "",
        birthday: null,
        street: "",
        postcode: null,
        town: "",
        phone: "",
        password: "",
        email: "",
        password: "",
        //membership_end: null,
        //member: false,
        roles: [],
        activated: true,
        member_of: [{
          section: "",
          active: false,
          start: null,
          end: null,
        }],
      },

      snackbar: false,
      snackbar_text: "",
      activeMembers: true
      

      //Users: [],
    };
  },
  async mounted() {
    await this.getSections({});
    await this.getUsers({});

    for (let user of this.Users) {
      user.birthday = this.$moment(user.birthday).format("YYYY-MM-DD");
    }

    
    //this.Users = this.Users;
    /*await this.getPersons({});

    for (let person of this.Persons) {
      person.updatedAt = this.$moment(person.updatedAt).format(
        "DD-MM-YYYY HH:mm"
      );
    }
    this.$forceUpdate();
    */
    //this.editedItemPerson = Object.assign({}, this.defaultItemPerson);
    this.editedItemUser = Object.assign({}, this.defaultItemUser);
  },
  computed: {
    ...mapState({
      status: ({ user }) => user.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
      Users: ({ user }) => user.Users,
      UserState: ({ user }) => user,
      Sections: ({ section }) => section.Sections,
      //Persons: ({ person }) => person.Persons,
      //PersonState: ({ person }) => person,
    }),

    /*formTitlePerson() {
      return this.editedIndexPerson === -1 ? "New Company" : "Edit Company";
    },*/
    formTitleUser() {
      return this.editedIndexUser === -1 ? "New User" : "Edit User";
    },
    filteredUsers() {
      let activeUsers = [];
      let inactiveUsers = [];
      
      if (this.Users){
        for (let user of this.Users) {
          inactiveUsers.push(user);
          for (let memberOf of user.member_of) {      
            if (memberOf.active) {
              activeUsers.push(user);
              inactiveUsers.pop();
              break;
            }
          }
        }
      }

      if (this.activeMembers) {     
        return activeUsers;
      } else {
        return inactiveUsers;
      }
    },
    title() {
      if (this.activeMembers) {return "Aktive Mitglieder"} else {return "Ehemalige Mitglieder"}
    }
  },
  methods: {
    ...mapActions("user", [
      "getUsers",
      "createUser",
      "readUser",
      "updateUser",
      "deleteUser",
    ]),
    ...mapActions("section", ["getSections"]),

    getSectionName(section_id) {
      if (this.Sections) {
        let section = _.find(this.Sections, { _id: section_id });
        if (section) {
          return section.name;
        }
        else {
          return ""
        }
      } else {
        return ""
      }
    },
    comp_site(member_of) {
      
      try {
        if (this.Sections) {
          let site_array = "";
          for (let member of member_of) {
            let section = _.find(this.Sections, { _id: member.section_id });
            if (section) {
              if (member.active) {
                site_array += section.name + ", "; 
              } else {
                 site_array += '(' +
                  section.name
                    .split("")
                    .map((char) => char + "\u0336")
                    .join("") + "), ";
              }
            }
          }
          return site_array;
        } else {
          return ""
        }
      } catch {
        return "";
      }
    },
    /*getSectionsText(member_of) {
      let arr = []
      return 
    },*/
    async editItemUser(item) {
      //console.log("editItem");
      this.editedIndexUser = this.Users.indexOf(item);
      this.editedItemUser = Object.assign({}, item);
      this.editedItemUser.password = "";
      /*try {
        this.editedItemUser.member_of = JSON.stringify(this.editedItemUser.member_of);
      } catch(err) {
        console.log("stringify failed")
      }*/
      //this.editedItemUser.birthday = this.$moment(this.editedItemUser.birthday).format("YYYY-MM-DD");
      this.dialog_user = true;
    },

    async deleteItemUser(item) {
      const index = this.Users.indexOf(item);
      await this.deleteUser(item._id);
      if (this.UserState.statusDelete == "success") {
        this.Users.splice(index, 1);
      } else {
        this.snackbar_text = "Already deleted";
        this.snackbar = true;
      }
    },

    closeUser() {
      this.dialog_user = false;
      this.$nextTick(() => {
        this.editedItemUser = Object.assign({}, this.defaultItem);
        this.editedIndexUser = -1;
      });
    },

    async saveUser() {
      //console.log("saveUser");

      //console.log(this.editedItemUser)
      /*try {
        this.editedItemUser.member_of = JSON.parse(this.editedItemUser.member_of);
      } catch(err) {
        console("stringify failed")
      }*/
      if (this.editedIndexUser > -1) {
        await this.updateUser(this.editedItemUser);

        if (this.UserState.statusUpdate == "success") {
          this.editedItemUser._id = this.UserState.User._id;
          this.editedItemUser.updatedAt = this.$moment(
            this.UserState.User.updatedAt
          ).format("DD-MM-YYYY HH:mm");
          Object.assign(this.Users[this.editedIndexUser], this.editedItemUser);
        } else {
          this.snackbar_text = this.UserState.User.message;
          this.snackbar = true;
        }
      } else {
        await this.createUser(this.editedItemUser);
        if (this.UserState.statusCreate == "success") {
          this.editedItemUser._id = this.UserState.User._id;
          this.editedItemUser.roles = ["user"];
          this.editedItemUser.activated = true;
          this.editedItemUser.updatedAt = this.$moment(
            this.UserState.User.updatedAt
          ).format("DD-MM-YYYY HH:mm");
          this.Users.push(this.editedItemUser);
        } else {
          this.snackbar_text = this.snackbar_text = this.UserState.User.message;
          this.snackbar = true;
        }
      }

      this.closeUser();
    },
    downloadCSV: function (data) {
      //https://github.com/d3/d3-dsv#dsv_format
      const _users = JSON.parse(JSON.stringify(this.Users));
      const options = {
        expandArrayObjects: true,
      };
      json2csvAsync(_users, options).then(async (res) => {
        //console.log(res);

        let blob = new Blob([res], {
          type: "text/csv;charset=utf-8",
        });

        const fileName = `${"users"}.csv`;

        try {
          await downloadFile(blob, fileName, "text/csv;charset=utf-8");
        } catch (e) {
          this.statusDownload = "failure";
          await setTimeout(() => {
            this.statusDownload = "";
          }, 5000);
        }
      });
    },
  },
  watch: {
    /*editedIndexPerson(item) {
      console.log(item);
    },*/
  },
};
</script>

<style>
.compact-form {
  transform: scale(0.9);
  transform-origin: left;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 10px !important;
}
</style>